export function cookies($) {

  function GetCookie(name) {
    var arg = name + "=";
    var alen = arg.length;
    var clen = document.cookie.length;
    var i = 0;



    while (i < clen) {
      var j = i + alen;

      if (document.cookie.substring(i, j) == arg) {
        return "1";
      }
      i = document.cookie.indexOf(" ", i) + 1;
      if (i == 0)
        break;
    }

    return null;
  }

  // Cookies
  function accept_cookies() {
    var expire = new Date();
    expire = new Date(expire.getTime() + 7776000000);
    document.cookie = "cookies_madblue=accept; expires=" + expire + ';' + "path=/; domain=" + window.location.hostname;
    var visit = GetCookie("cookies_madblue");

    if (visit == 1) {
      cookiebox();
    }
  }

  $(function () {
    var visit = GetCookie("cookies_madblue");
    if (visit == 1) {
      cookiebox();
    } else {
      // COOKIES
      // $('#cookies').show();
      $('body').addClass('cookiesVisible');
      $('.button-cookies').click(function (e) {
        accept_cookies();
      });
    }
  });

  function cookiebox() {
    $('body').removeClass('cookiesVisible');
  }
}
